export default __webpack_public_path__ + "static/depoimento-1-2245821353142f53275287f485e4ba2f.svg";